import CustomSelect from "@/components/ui/input/CustomSelect";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import clsx from "clsx";
import React, { useState, useEffect } from "react";

function FerryChildSelect({ childCount, tempValues, setTempValues }) {
  const t = useTranslationDetector();
  const isMobile = useIsMobile();

  const [localChildAges, setLocalChildAges] = useState(() =>
    Array.from({ length: childCount }, (_, i) => tempValues?.childAges?.[i] ?? "")
  );

  useEffect(() => {
    setLocalChildAges(
      Array.from({ length: childCount }, (_, i) => tempValues?.childAges?.[i] ?? "")
    );
  }, [childCount, tempValues?.childAges]);

  if (!childCount || childCount === 0) {
    return null;
  }

  const ages = Array.from({ length: 11 }, (_, i) => ({
    value: String(i + 1),
    label: String(i + 1), // 1 - 11 yaş
  }));

  const handleChange = (index) => (e) => {
    const value = e.target.value;
    setLocalChildAges((prev) => {
      const next = [...prev];
      next[index] = value;
      setTempValues((tempPrev) => ({ ...tempPrev, childAges: next }));
      return next;
    });
  };

  return (
    <div className="flex flex-col gap-4 p-4 pt-2">
      {Array.from({ length: childCount }).map((_, idx) => (
        <div key={idx} className="flex items-center justify-between">
          <label
            htmlFor={`childAge_${idx}`}
            className="text-foreground"
          >
            {`${idx + 1}. ${t("ferry.childAgeLabel")}`}
          </label>
          <CustomSelect
            buttonClassName={
              clsx(
                "!border-solid !h-12",
                isMobile ? "!w-[180px]" : "!w-[138px]",
              )
            }
            buttonIconClassName="!w-6 !h-6"
            name={`childAge_${idx}`}
            id={`childAge_${idx}`}
            value={localChildAges?.[idx] ?? ""}
            onChange={handleChange(idx)}
            options={ages}
            placeholder={t("ferry.childAgeSelectPlaceholder")}
            searchable={false}
            showPlaceholder
            mobileDropdownClassName="max-h-[90dvh]! md:max-h-[90dvh]!"
          />
          {/* <Select
            className="mt-0 w-[180px] md:w-[138px]"
            id={`childAge_${idx}`}
            options={ages}
            placeholder={t("ferry.childAgeSelectPlaceholder")}
            value={selectedAges?.[idx] ?? ""}
            onChange={handleChange(idx)}
            showPlaceholder
          /> */}
        </div>
      ))}
    </div>
  );
}

export default FerryChildSelect;
